/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

/**
 * Reports whether a channel label is present in a list of enabled thumbnail channels. Compares the channel's label against each entry with lodash some.
 *
 * @param channels - Enabled channel labels.
 * @param channel - Channel whose label is looked for.
 * @returns True when the list contains the channel's label.
 */
const checkHasChannel = (channels: any[], channel: { label: any }) =>
  _.some(channels, (x) => x === channel.label);

export { checkHasChannel };
